import { createStore } from 'vuex'

export default createStore({
  state: {
	  // 一些变量存储
  },
  mutations: {
	  // 一些方法（）改变store的变量，通过commit（）提交
	  increse(){
		  
	  },
	  // 类型变量的使用，目的是防止写错单词
	  decrese(){
		  
	  }
  },
  actions: {
  },
  modules: {
  },
  getters: {
	  // 相当于计算属性
	  more20stu(state){
		  
	  },
	  more20stu11(state, getters){
		  
	  },
	  more20stu22(state){
		  return function(age){
			  return null;
		  }
	  }
  }
})
